import {create} from 'zustand';
import {MotivatorsStore} from './types';

export const useMotivatorsStore = create<MotivatorsStore>(set => ({
	motivatorsValues: {},

	setMotivatorValue: (motivator, index, answer) =>
		set(state => {
			const key = motivator.id;
			const currentList = state.motivatorsValues[key] ?? [];

			const updated = [...currentList];
			const original = motivator.questoes_3_estrelas_abaixo[index];

			updated[index] = {
				descricao: original.descricao,
				id_quest_3_estrelas_abaixo: original.id_quest_3estrelas_abaixo,
				resposta: answer,
			};

			return {
				motivatorsValues: {
					...state.motivatorsValues,
					[key]: updated,
				},
			};
		}),

	resetMotivatorValues: motivator =>
		set(state => {
			const key = motivator.id;

			return {
				motivatorsValues: {
					...state.motivatorsValues,
					[key]: motivator.questoes_3_estrelas_abaixo.map(question => ({
						descricao: question.descricao,
						id_quest_3_estrelas_abaixo: question.id_quest_3estrelas_abaixo,
						resposta: '',
					})),
				},
			};
		}),
}));
